module.exports = __webpack_public_path__ + "static/media/unchecked_circle.cd22a95e.svg";